import React from 'react';
import { Box } from '@mui/material';
import { AppContent, AppSidebar, AppFooter, AppHeader, AppBreadcrumb } from '../components/index';

const DefaultLayout = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppHeader />
      <Box sx={{ display: 'flex', flex: 1 }}>
        <AppSidebar />
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 'calc(100vh - 64px)',
            minWidth: 0,
          }}
        >
          <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2 }}>
            <AppBreadcrumb />
          </Box>
          <AppContent />
          <AppFooter />
        </Box>
      </Box>
    </Box>
);

export default DefaultLayout;
